import React, {
	useState,
	useEffect
} from "react";
import Cookies from "js-cookie";
import "./AlertBar.scss";
import sanitizeHtml from "sanitize-html";
import {
	Typography,
	Button,
	Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/HighlightOffSharp";
import { useDispatch } from "react-redux";
import { setAlertBarCount } from "../../../store/rootSlice";

// Matches the page offset in App. One row per visible banner.
export const ALERT_BAR_ROW_HEIGHT_PX = 55;

const BANNER_COOKIE = "banner";
const bannerCookieOptions = { expires: 365, path: "/", sameSite: "strict" };

const readDismissedBannerIds = () => {
	const raw = Cookies.get(BANNER_COOKIE);
	if (!raw) {
		return [];
	}

	try {
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};

const rememberDismissedBanner = (id) => {
	const dismissedIds = readDismissedBannerIds();
	if (dismissedIds.includes(id)) {
		return dismissedIds;
	}

	const nextIds = [...dismissedIds, id];
	Cookies.set(BANNER_COOKIE, JSON.stringify(nextIds), bannerCookieOptions);
	return nextIds;
};

const currentBanners = (bannerdata) => (
	Array.isArray(bannerdata) ? bannerdata.filter((banner) => banner && banner.id !== undefined) : []
);

export default function AlertBar({ bannerdata }) {

	const dispatch = useDispatch();
	const [dismissedIds, setDismissedIds] = useState(readDismissedBannerIds);

	const visibleBanners = currentBanners(bannerdata).filter(
		(banner) => !dismissedIds.includes(banner.id)
	);

	useEffect(() => {
		dispatch(setAlertBarCount(visibleBanners.length));
	}, [dispatch, visibleBanners.length]);

	const onClickDismissMessage = (id) => {
		setDismissedIds(rememberDismissedBanner(id));
	};

	return (
		<Box
			className="alert-bar"
			data-testid="alert-bar"
			style={{ "--alert-bar-row-height": `${ALERT_BAR_ROW_HEIGHT_PX}px` }}
		>

			{visibleBanners.map((banner) => (
				<Box
					key={banner.id}
					className="alert-box"
					data-testid="alert-box"
				>
					<Typography
						component="p"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(banner.banner_text) }}
					/>
					<Button
						variant="text"
						sx={{ color: "text.secondary", marginLeft: "1rem" }}
						onClick={() => onClickDismissMessage(banner.id)}
						title="Dismiss Message"
					>
						<CloseIcon />
					</Button>
				</Box>
			))}

		</Box>
	);

}
